import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

const NameSkeleton = styled(PixelPlaceholderLoader)`
    max-width: 140px;
    margin-bottom: 16px;
`;
const VolumeSkeleton = styled(PixelPlaceholderLoader)`
    margin-bottom: 8px;
`;
const ChangeSkeleton = styled(PixelPlaceholderLoader)`
    margin-bottom: 8px;
    border-radius: 100px;
`;
const TrendSkeleton = styled(PixelPlaceholderLoader)``;

const TopicCardSkeleton = () => (
    <Box
        flex="0 1 calc(25% - 8px)"
        height="188px"
        padding="16px"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        alignSelf="stretch"
        borderRadius="6px"
        border={`1px solid ${colorsPalettes.carbon[50]}`}
        background={colorsPalettes.carbon[0]}
    >
        <NameSkeleton
            width="100%"
            height={16}
        />
        <VolumeSkeleton
            width={104}
            height={24}
        />
        <ChangeSkeleton
            width={80}
            height={24}
        />
        <TrendSkeleton
            width="100%"
            height={56}
        />
    </Box>
);

const cardSkeletons = Array.from({ length: 4 }).map((_, index) => (
    <TopicCardSkeleton key={`trending-topic-skeleton-${index}`} />
));

export const TopicsDiscoverTrendCardsSkeleton = () => {
    return cardSkeletons;
};
